// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-pagination-item {\n  border-radius: 4px; }\n  .ant-pagination-item a {\n    color: #595959; }\n\n.ant-pagination-item-active a {\n  color: #1890ff; }\n\n.ant-pagination-prev .anticon, .ant-pagination-next .anticon {\n  position: relative;\n  top: -1px; }\n\n.Pagination_wrapper__3JvS3.Pagination_center__ZWTx- {\n  text-align: center; }\n\n.Pagination_wrapper__3JvS3.Pagination_right__Xp4g8 {\n  text-align: right; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "Pagination_wrapper__3JvS3",
	"center": "Pagination_center__ZWTx-",
	"right": "Pagination_right__Xp4g8"
};
module.exports = exports;
